/* Sword Slice header: keyboard support for menus and live cart count */
(function () {
  'use strict';

  var nav = document.getElementById('ss-nav');
  if (!nav) return;

  /* ---------- Keyboard support for the desktop menu ---------- */
  var topItems = Array.prototype.slice.call(document.querySelectorAll('#ss-links > li'));

  function topControl(li) {
    return li.querySelector('span') || li.querySelector('a');
  }

  topItems.forEach(function (li) {
    var trigger = li.querySelector('span');
    var panel = li.dataset.p ? document.getElementById('p-' + li.dataset.p) : null;
    if (!trigger || !panel) return;

    trigger.setAttribute('tabindex', '0');
    trigger.setAttribute('role', 'button');
    trigger.setAttribute('aria-haspopup', 'true');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-controls', panel.id);

    var links = function () {
      return Array.prototype.slice.call(panel.querySelectorAll('a'));
    };
    var isOpen = function () {
      return panel.classList.contains('open');
    };
    var open = function () {
      li.dispatchEvent(new MouseEvent('mouseenter'));
    };
    var close = function () {
      li.dispatchEvent(new MouseEvent('mouseleave'));
    };
    var focusLink = function (index) {
      var list = links();
      if (!list.length) return;
      list[(index + list.length) % list.length].focus();
    };

    new MutationObserver(function () {
      trigger.setAttribute('aria-expanded', isOpen() ? 'true' : 'false');
    }).observe(panel, { attributes: true, attributeFilter: ['class'] });

    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
        e.preventDefault();
        if (!isOpen()) open();
        window.requestAnimationFrame(function () { focusLink(0); });
      } else if (e.key === 'Tab' && !e.shiftKey && isOpen()) {
        e.preventDefault();
        focusLink(0);
      } else if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault();
        var next = topItems[topItems.indexOf(li) + (e.key === 'ArrowRight' ? 1 : -1)];
        if (next) topControl(next).focus();
      }
    });

    panel.addEventListener('keydown', function (e) {
      var list = links();
      var i = list.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); focusLink(i + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); focusLink(i - 1); }
      else if (e.key === 'Home') { e.preventDefault(); focusLink(0); }
      else if (e.key === 'End') { e.preventDefault(); focusLink(list.length - 1); }
      else if (e.key === 'Escape') { close(); trigger.focus(); }
      else if (e.key === 'Tab' && e.shiftKey && i === 0) {
        e.preventDefault();
        trigger.focus();
      }
    });

    panel.addEventListener('focusout', function (e) {
      var to = e.relatedTarget;
      if (to && (panel.contains(to) || li.contains(to))) return;
      if (isOpen() && to) close();
    });

    trigger.addEventListener('blur', function (e) {
      var to = e.relatedTarget;
      if (!to || panel.contains(to) || li.contains(to)) return;
      if (isOpen()) close();
    });
  });

  /* ---------- Mobile drawer state for assistive tech ---------- */
  var ham = document.getElementById('ss-ham');
  if (ham) {
    ham.setAttribute('aria-expanded', 'false');
    ham.setAttribute('aria-controls', 'ss-mobile-drawer');
    new MutationObserver(function () {
      ham.setAttribute('aria-expanded', ham.classList.contains('open') ? 'true' : 'false');
    }).observe(ham, { attributes: true, attributeFilter: ['class'] });
  }
  Array.prototype.forEach.call(document.querySelectorAll('.ss-mob-section'), function (section) {
    var btn = section.querySelector('.ss-mob-trigger');
    if (!btn) return;
    btn.setAttribute('aria-expanded', 'false');
    new MutationObserver(function () {
      btn.setAttribute('aria-expanded', section.classList.contains('open') ? 'true' : 'false');
    }).observe(section, { attributes: true, attributeFilter: ['class'] });
  });

  /* ---------- Mobile sub dropdowns: each group heading opens its own links ---------- */
  function fitBody(el) {
    var body = el.closest('.ss-mob-body');
    if (body && body.style.maxHeight) {
      body.style.maxHeight = 'none';
    }
  }

  Array.prototype.forEach.call(document.querySelectorAll('.ss-mob-subcol'), function (col) {
    var head = col.querySelector('.ss-mob-subhead');
    var anchors = Array.prototype.filter.call(col.children, function (c) { return c.tagName === 'A'; });
    if (!head || !anchors.length || col.classList.contains('ss-sub')) return;

    var list = document.createElement('div');
    list.className = 'ss-mob-sublist';
    list.id = 'ss-sub-' + Math.random().toString(36).slice(2, 8);
    anchors.forEach(function (a) { list.appendChild(a); });
    col.appendChild(list);
    col.classList.add('ss-sub');

    head.setAttribute('role', 'button');
    head.setAttribute('tabindex', '0');
    head.setAttribute('aria-expanded', 'false');
    head.setAttribute('aria-controls', list.id);

    function toggle() {
      var open = col.classList.toggle('ss-sub-open');
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
      fitBody(col);
    }
    head.addEventListener('click', function (e) {
      e.preventDefault();
      toggle();
    });
    head.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle();
      }
    });
  });

  /* ---------- Cart count ---------- */
  var cartLinks = function () {
    return document.querySelectorAll('.ss-icons a[aria-label="Cart"], .ss-mob-cart a[aria-label="Cart"]');
  };

  function setBadge(count) {
    Array.prototype.forEach.call(cartLinks(), function (a) {
      var badge = a.querySelector('.ss-badge');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'ss-badge';
          a.appendChild(badge);
        }
        badge.textContent = count > 99 ? '99+' : String(count);
      } else if (badge) {
        badge.parentNode.removeChild(badge);
      }
    });
  }

  var refreshTimer = null;
  function refreshCount() {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) { setBadge(cart.item_count); })
        .catch(function () {});
    }, 150);
  }

  var cartRequest = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var result = nativeFetch.apply(this, arguments);
      if (cartRequest.test(url)) {
        result.then(refreshCount, function () {});
      }
      return result;
    };
  }

  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && cartRequest.test(url)) {
      this.addEventListener('loadend', refreshCount);
    }
    return nativeOpen.apply(this, arguments);
  };

  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCount(); });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) refreshCount();
  });
})();